import { Types } from '@fiverr-private/theme';
import { ChoiceGroupItemProps, SizeType } from '../types';

interface GenerateStylingProps<T> {
    checkboxPositioning: ChoiceGroupItemProps<T>['checkboxPositioning'];
    size: SizeType;
}

const getPositionStylingProps = <T>(position: ChoiceGroupItemProps<T>['checkboxPositioning']): Types.ContainerProps => {
    switch (position) {
        case 'static':
            return {
                position: 'static',
                marginBottom: 'auto',
            };
        case 'absolute':
            return {
                position: 'absolute',
            };
        case 'center':
            return {
                display: 'flex',
                alignItems: 'center',
            };
        default:
            return {};
    }
};

export const generateStylingProps = <T>({
    checkboxPositioning,
    size,
}: GenerateStylingProps<T>): { containerStylingProps?: Types.Box; checkboxStylingProps?: Types.ContainerProps } => {
    const positionStylingProps = getPositionStylingProps(checkboxPositioning);
    const isAbsolute = checkboxPositioning === 'absolute';

    const sizeMap: Record<SizeType, { containerStylingProps: Types.Box; checkboxStylingProps: Types.ContainerProps }> =
        {
            sm: {
                containerStylingProps: {
                    paddingY: '1.5',
                    paddingX: '3',
                    lineHeight: 'b_sm',
                    fontSize: 'b_sm',
                },
                checkboxStylingProps: {
                    ...positionStylingProps,
                    ...(isAbsolute && { top: '6px', right: '12px' }),
                },
            },
            md: {
                containerStylingProps: {
                    paddingY: '2',
                    paddingX: '3',
                },
                checkboxStylingProps: {
                    ...positionStylingProps,
                    ...(isAbsolute && { top: '8px', right: '12px' }),
                },
            },
            xl: {
                containerStylingProps: {
                    paddingY: '5',
                    paddingX: '6',
                },
                checkboxStylingProps: {
                    ...positionStylingProps,
                    ...(isAbsolute && { top: '20px', right: '24px' }),
                },
            },
        };

    return sizeMap[size] || {};
};
